export const ADDED = 'simplecasino/countries/ADDED'
export const ALL_ADDED = 'simplecasino/countries/ALL_ADDED'
